import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import AOS from "aos";
import "aos/dist/aos.css";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    marginTop: "5rem",
    padding: "1rem",
  },

  menuDiv: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#E7A977",
    padding: "1rem",
  },
  menuItems: {
    display: "flex",
    justifyContent: "flex-start",
    padding: "1rem",
  },
  priceItems: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "1rem",
  },
}));
const serifFont = createMuiTheme({
  typography: {
    fontFamily: ["Old Standard TT", "serif"].join(","),
  },
});
export default function Menu() {
  const classes = useStyles();
  useEffect(() => {
    AOS.init({});
  }, []);
  return (
    <Grid container className={classes.bg} direction="column">
      <Typography
        data-aos="zoom-in"
        data-aos-duration="1000"
        variant="h3"
        style={{
          fontWeight: 300,
          backgroundColor: "#c8878d",
          padding: "1rem",
          maxWidth: "14rem",
        }}
        gutterBottom
      >
        Thực đơn
      </Typography>
      <ThemeProvider theme={serifFont}>
        <Typography
          variant="h3"
          gutterBottom
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          MÓN CHÍNH
        </Typography>
      </ThemeProvider>
      <Grid container direction="row" className={classes.menuDiv}>
        <Grid
          item
          direction="column"
          className={classes.menuItems}
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <Typography variant="h6">Tô bắp</Typography>
          <Typography variant="h6">Tô bắp gân</Typography>
          <Typography variant="h6">Tô bắp giò</Typography>
          <Typography variant="h6">Tô bắp bò viên</Typography>
          <Typography variant="h6">Tô đặc biệt</Typography>
        </Grid>
        <Grid
          item
          direction="column"
          className={classes.priceItems}
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <Typography variant="h6">35,000</Typography>
          <Typography variant="h6">45,000</Typography>
          <Typography variant="h6">45,000</Typography>
          <Typography variant="h6">45,000</Typography>
          <Typography variant="h6">55,000</Typography>
        </Grid>
      </Grid>
      <ThemeProvider theme={serifFont}>
        <Typography
          variant="h3"
          style={{ marginTop: "1rem" }}
          gutterBottom
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          ĂN THÊM
        </Typography>
      </ThemeProvider>
      <Grid container direction="row" className={classes.menuDiv}>
        <Grid
          item
          direction="column"
          className={classes.menuItems}
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <Typography variant="h6">Chén giò</Typography>
          <Typography variant="h6">Chén bắp</Typography>
          <Typography variant="h6">Chén gân</Typography>
          <Typography variant="h6">Chén bò viên</Typography>
        </Grid>
        <Grid
          item
          direction="column"
          className={classes.priceItems}
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <Typography variant="h6">20,000</Typography>
          <Typography variant="h6">20,000</Typography>
          <Typography variant="h6">20,000</Typography>
          <Typography variant="h6">20,000</Typography>
        </Grid>
      </Grid>
      <ThemeProvider theme={serifFont}>
        <Typography
          variant="h3"
          style={{ marginTop: "1rem" }}
          gutterBottom
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          GIẢI KHÁT
        </Typography>
      </ThemeProvider>
      <Grid container direction="row" className={classes.menuDiv}>
        <Grid
          item
          direction="column"
          className={classes.menuItems}
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <Typography variant="h6">Nước suối</Typography>
          <Typography variant="h6">Nước ngọt</Typography>
          <Typography variant="h6">Chanh xả mật ong</Typography>
          <Typography variant="h6">Trà đá</Typography>
        </Grid>
        <Grid
          item
          direction="column"
          className={classes.priceItems}
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <Typography variant="h6">12,000</Typography>
          <Typography variant="h6">15,000</Typography>
          <Typography variant="h6">12,000</Typography>
          <Typography variant="h6">2,000</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
